export const defaultLocale = localStorage.getItem('defaultLocale') ? localStorage.getItem('defaultLocale') : 'en'
export const languages = ['pl', 'en'];
